import { Box, styled } from '@mui/material';
import { Button, Popup } from '@elements';
import { pxToRem } from '@themes';
var StyledPopup = styled(Popup)(function (_ref) {
  var theme = _ref.theme;
  return {
    borderRadius: pxToRem(16)
  };
});
var StyledHeader = styled(Box)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: 'flex',
    justifyContent: 'flex-start'
  };
});
var StyledContent = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: theme.spacing(2.5),
    paddingTop: theme.spacing(1)
  };
});
var StyledButton = styled(Button)(function (_ref4) {
  var theme = _ref4.theme,
      fullWidth = _ref4.fullWidth;
  var styles = {
    '&&': {
      padding: theme.spacing(0),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: fullWidth ? '100%' : '40px',
      height: '40px',
      borderRadius: theme.typography.pxToRem(12),
      backgroundColor: theme.palette.internationalOrange.main,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: theme.palette.white.main,
      textTransform: 'uppercase',
      ':disabled': {
        backgroundColor: theme.palette.silverChalice.main,
        borderColor: theme.palette.silverChalice.main
      }
    }
  };
  return styles;
});
export { StyledButton, StyledContent, StyledHeader, StyledPopup };